/**
 * 動画素材が選べないコンテキストで動画が選ばれたとき (assetsContext の videoEditOffer) の扱いを
 * 決める純関数。GenerationWorkspace の effect / 確認モーダルがこれに従う。
 *
 * - 静止画タブ: 確認モーダルを出す ('confirm')。productionMode / promptVideoGenerationMode は
 *   動画タブから残ったままのことがある (ScenarioGenerator がアンマウントされるため) ので、先に判定する
 * - 動画タブのシナリオ生成: 切り替えずに断る ('rejectScenario')
 * - 動画タブのプロンプト入力モードで「モーショングラフィックス」: 動画編集へ切り替えると motion から
 *   外れるので、レイヤー素材が必要な旨を案内して断る ('rejectMotion'・motion-graphics-mode-plan.md §3.4・§5.2)
 * - それ以外 (プロンプト入力モードの v2v 非対応モデル等): 即座に動画編集へ切り替える ('accept')
 */
export type VideoEditOfferAction = 'confirm' | 'rejectScenario' | 'rejectMotion' | 'accept';

export function resolveVideoEditOfferAction({
  activeTab,
  productionMode,
  promptVideoGenerationMode,
}: {
  activeTab: string;
  productionMode: 'scenario' | 'prompt';
  promptVideoGenerationMode: string | null;
}): VideoEditOfferAction {
  if (activeTab === 'stillImage') return 'confirm';
  if (productionMode !== 'prompt') return 'rejectScenario';
  if (activeTab === 'scenario' && promptVideoGenerationMode === 'motion') return 'rejectMotion';
  return 'accept';
}
